import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formateDateWithTime } from "../../../utils/commonFunctions";
import { BulkUploadHistoryDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { HrmsBulkUploadHistoryDataType } from "../../../redux/hrms/hrmsTypes";

type AppProps = {
  tableHeaders: TableHeadersType[];
  data: BulkUploadHistoryDataType[] | HrmsBulkUploadHistoryDataType[] | [];
};

const BulkUploadData = ({ tableHeaders, data }: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  function isNotEmpty(obj: any) {
    return Object.keys(obj).length !== 0;
  }

  return (
    <>
      {data?.map((dataItem: any) => {
        let isProcessing = dataItem?.is_processing ? dataItem?.is_processing : dataItem?.processing_status;
        let file = dataItem?.file;
        
        return (
          <tr key={dataItem?.id}>
            {tableHeaders?.length &&
              tableHeaders?.map((item: any) => {
                if (item?.value === "stage") {
                  return (
                    <td>
                      <div
                        style={{
                          color: !!isProcessing ? "#e7733e" : "#82b01f",
                          background: !!isProcessing ? "#faedd8" : "#e7f0d4",
                          width: "fit-content",
                          padding: "5px 10px",
                          borderRadius: "30px",
                        }}
                      >
                        {!!isProcessing ? "Processing" : "Ready"}
                      </div>
                    </td>
                  );
                } else if (item?.value === "file_name") {
                  return (
                    <td>{file?.file_name ? file?.file_name : " --/-- "}</td>
                  );
                } else if (item?.value === "file_url") {
                  return (
                    <td>
                      <a
                        href={blobBaseUrl + file?.file_url + "?" + blobToken}
                        style={{ textDecoration: "none" }}
                      >
                        {file?.file_url && isNotEmpty(file.file_url)
                          ? file.file_url
                          : " --/-- "}
                      </a>
                    </td>
                  );
                } else if (dataItem[item.value]) {
                  return <td>{formateDateWithTime(dataItem[item.value])}</td>;
                } else {
                  return <td className="text-left"> --/-- </td>;
                }
              })}
          </tr>
        );
      })}
    </>
  );
};

export default BulkUploadData;
